export const move = (obj, from, to) => {
  let fromObj = obj;
  let parentFrom;

  const fromArr = from.split('.');
  for (const a of fromArr) {
    parentFrom = fromObj;
    fromObj = fromObj[a];
    if (! fromObj) return;
  }

  if (to === undefined) {
    delete parentFrom[fromArr[fromArr.length - 1]];
  }
  
  let toObj = obj;
  let parentTo;

  const toArr = to.split('.');
  for (const a of toArr) {
    if (! (a in toObj)) {
      toObj[a] = {};
    }
    parentTo = toObj;
    toObj = toObj[a];
  }

  if (typeof fromObj === 'object') {
    parentTo[toArr[toArr.length - 1]] = { ...parentTo[toArr[toArr.length - 1]], ...fromObj };
  } else {
    parentTo[toArr[toArr.length - 1]] = fromObj;
  }
  delete parentFrom[fromArr[fromArr.length - 1]];
}